import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { useScrollTo } from '../../../helpers';

import RequestAQuote from './RequestAQuote';

import getComponentPaths from './lib/getComponentPaths';

const RequestAQuoteController = ({
  childCategories,
  contactValues,
  location,
  setContactValues,
  topCategoryItem,
}) => {

  const allowScrollRef = useRef(false);

  const allowScroll = () => {
    // allowScrollRef.current = true;
  };

  const formTopRef = useRef(null);
  const formDetailRef = useRef(null);

  const scrollToFormTop = useScrollTo(formTopRef);
  const scrollToFormDetail = useScrollTo(formDetailRef);

  const [defaultValues, setDefaultValues] = useState({});
  const [formExists, setFormExists] = useState(false);
  const [fields, setFields] = useState([]);
  // const [formDetails, setFormDetails] = useState(null);

  const [formName, setFormName] = useState('');

  const urlEls = location.hash.slice(1).split('/').filter((el) => el);
  const element = urlEls[urlEls.length - 1];

  const componentPaths = getComponentPaths(urlEls);

  /**
   * We need to create a map of parent categories to their children.
   * Children may be another category, or a form.
   * The object will be similar to the below:
   */
  /*
    const menus = {
      'signs-graphics': [
        'interior-signs',
        'exterior-signs',
        'vinyl-lettering-and-vinyl-decals',
        'donor-walls-and-recognition-plaques',
        'dimensional-letters-3d-logos',
        'illuminated-signage',
        'site-signs-and-safety-signs',
      ],
      'interior-signs': [
        'braille-ada-signs',
        'directional-wayfinding',
        'door-signs',
      ],
      'exterior-signs': [
        'building-signage',
        'directional-and-wayfinding',
        'parking-lot-signs',
      ],
      'vinyl-lettering-and-vinyl-decals': [
        'banners',
        'frosted-window-film',
        'sandwich-boards',
        'vehicle-graphic',
        'wall-graphics',
        'window-and-door-graphics',
      ],
    };
  */

 // map UID to our categories
 // we'll need to look up the category based on parentUid
 const uidToCategoryMap = {};

 // get the categories from the childCategories
  const categories = childCategories.map(({ node }, i) => {
    const children = childCategories.filter((item) => item.node.parentUid === node.uid);
    if (children.length > 0) {
      const category = node.path.split('/').filter((el) => el).pop();
      uidToCategoryMap[node.uid] = category;
      return category;
    }
  }).filter((el) => el);


  // insert topCategoryItem into the beginning of the categories array
  const topCategory = topCategoryItem.path.split('/').filter((el) => el).pop();
  categories.unshift(topCategory);
  uidToCategoryMap[topCategoryItem.uid] = topCategory;

  const menus = {};

  categories.forEach((category) => {
    menus[category] = childCategories.map(({ node }, i) => {
      if (uidToCategoryMap[node.parentUid] === category) {
        return node.path.split('/').filter((el) => el).pop();
      }
    }).filter((el) => el);
  });

  // Populate the forms array with the slugs for each form.
  const forms = Object.keys(menus).reduce((acc, category) => {
    const subEls = menus[category];
    subEls.forEach((subEl) => {
      // Don't include top level form items.
      if (categories.includes(subEl)) {
        return;
      }
      acc.push(subEl);
    });
    return acc;
  }, []);

  useEffect(() => {
    import(`${componentPaths.defaultValues}`)
    .then((module) => {
      setDefaultValues(module.default);
      setFormExists(true);
    })
    .catch((error) => {
      // console.log(error);
      setFormExists(true);
    });
  }, [componentPaths.defaultValues]);

  useEffect(() => {
    import(`${componentPaths.fields}`)
    .then((module) => {
      setFields(module.default);
    })
    .catch((error) => {
      setFields([]);
    });
  }, [componentPaths.fields]);

  useEffect(() => {
    import(`${componentPaths.formName}`)
    .then((module) => {
      setFormName(module.default);
    })
    .catch((error) => {
      setFormName(componentPaths.base);
    });
  }, [componentPaths.fields]);

  useEffect(() => {
    if (formExists) {
      if (allowScrollRef.current) {
        scrollToFormDetail();
      } else {
        allowScroll.current = true;
      }
    } else {
      if (allowScrollRef.current) {
        scrollToFormTop();
      } else {
        allowScroll.current = true;
      }
    }
  }, [formExists]);


  // can we lazy load the form component without
  // infinite rerenders if it's in a useEffect?
  /*
  useEffect(() => {
    import(`${componentPaths.component}/Component.js`)
    .then((module) => {
      console.log('FormDetails');
      console.log(componentPaths.component);
      console.log(module.default);
      setFormDetails(module.default);
    })
    .catch((error) => {
      console.log(error);
    });
  }, [componentPaths.component]);
  */

  return (
    <RequestAQuote
      allowScroll={allowScroll}
      childCategories={childCategories}
      component={componentPaths.component}
      contactValues={contactValues}
      defaultValues={defaultValues}
      fields={fields}
      formDetailRef={formDetailRef}
      formExists={formExists}
      formName={formName}
      formTopRef={formTopRef}
      location={location}
      setContactValues={setContactValues}
      topCategoryItem={topCategoryItem}
    />
  );
};

RequestAQuoteController.propTypes = {
  childCategories: PropTypes.array.isRequired,
  contactValues: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  setContactValues: PropTypes.func.isRequired,
  topCategoryItem: PropTypes.object.isRequired,
};

export default RequestAQuoteController;
